import Layouts from './Layout';

export default Layouts;
